import React from 'react';

function Spinner({ size = 'md', className = '' }) {
  const sizeClasses = {
    sm: 'spinner-sm',
    md: 'spinner',
    lg: 'spinner-lg'
  };

  return (
    <div className={`${sizeClasses[size]} ${className}`} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default Spinner;
